<template lang='pug'>
//- 已存在提示區塊
div(:class='$style[`cc-popbox-exist-resume`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-new`]')
    IconWarn(:size='70')
    span.font-medium(:class='$style[`cc-popbox-exist-info`]') 你已經有故事卡!

    div(:class='$style[`cc-content-btn-area`]')
      div(
        title='前往查看'
        :class='$style[`cc-content-btn`]'
        @click='handleClickToRedirect')
        span 前往查看


</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import IconWarn from '../../icon/Warn';

export default {
  components: {
    IconWarn,
  },

  data() {
    return {
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changeUpdateKey: 'global/FORCE_UPDATE_KEY',
    }),

    handleClosePopBox() {
      this.changePopBoxStatus({
        active: false,
        include: '',
      });
    },

    handleClickToRedirect() {
      if (this.$router.currentRoute.name === 'profile-resume') {
        this.changeUpdateKey();
      } else {
        this.$router.push({
          name: 'profile-resume',
          params: {
            type: 'normal',
            id: this.loginDjangoId,
          },
        }).catch(() => true);
        this.handleClosePopBox();
      }
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      // loginStatus: 'user/exportLoginStatus',
      // loginProfile: 'user/exportUserProfile',
      loginDjangoId: 'user/exportUserDjangoId',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popResumeExist.scss';
</style>
